import { gql } from '@apollo/client';

// Bulletin Board Queries
export const LIST_MY_BULLETIN_POSTS = gql`
  query ListMyBulletinPosts($limit: Int, $nextToken: String) {
    listMyBulletinPosts(limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        audienceType
        creatorId
        creator {
          id
          firstName
          lastName
          role
        }
        createdAt
        updatedAt
        isDeleted
        targetedUserIds
        priority
        isPinned
        images {
          id
          url
          thumbnailUrl
          width
          height
          size
        }
        attachments {
          id
          url
          fileName
          fileType
          fileSize
          uploadedAt
          isImage
        }
        reactions {
          thumbsUp
          heart
          party
          eyes
        }
      }
      nextToken
    }
  }
`;

export const GET_BULLETIN_POST = gql`
  query GetBulletinPost($id: ID!) {
    getBulletinPost(id: $id) {
      id
      content
      audienceType
      creatorId
      creator {
        id
        firstName
        lastName
        role
      }
      createdAt
      updatedAt
      isDeleted
      targetedUserIds
      priority
      isPinned
      images {
        id
        url
        thumbnailUrl
        width
        height
        size
      }
      attachments {
        id
        url
        fileName
        fileType
        fileSize
        uploadedAt
        isImage
      }
      reactions {
        thumbsUp
        heart
        party
        eyes
      }
    }
  }
`;

export const LIST_ALL_BULLETIN_POSTS = gql`
  query ListAllBulletinPosts($limit: Int, $nextToken: String) {
    listAllBulletinPosts(limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        audienceType
        creatorId
        creator {
          id
          firstName
          lastName
          role
        }
        createdAt
        updatedAt
        isDeleted
        deletedAt
        deletedBy
        targetedUserIds
        priority
        isPinned
        images {
          id
          url
          thumbnailUrl
          width
          height
          size
        }
        attachments {
          id
          url
          fileName
          fileType
          fileSize
          uploadedAt
          isImage
        }
      }
      nextToken
    }
  }
`;

// Query to get bulletin attachment upload URL
export const GET_BULLETIN_ATTACHMENT_UPLOAD_URL = gql`
  query GetBulletinAttachmentUploadUrl($input: GetBulletinAttachmentUploadUrlInput!) {
    getBulletinAttachmentUploadUrl(input: $input) {
      uploadUrl
      s3Key
      publicUrl
    }
  }
`;

// Bulletin Board Mutations
export const CREATE_BULLETIN_POST = gql`
  mutation CreateBulletinPost($input: CreateBulletinPostInput!) {
    createBulletinPost(input: $input) {
      id
      content
      audienceType
      creatorId
      creator {
        id
        firstName
        lastName
        role
      }
      createdAt
      updatedAt
      isDeleted
      targetedUserIds
      priority
      isPinned
      images {
        id
        url
        thumbnailUrl
        width
        height
        size
      }
      attachments {
        id
        url
        fileName
        fileType
        fileSize
        uploadedAt
        isImage
      }
      reactions {
        thumbsUp
        heart
        party
        eyes
      }
    }
  }
`;

export const UPDATE_BULLETIN_POST = gql`
  mutation UpdateBulletinPost($id: ID!, $input: UpdateBulletinPostInput!) {
    updateBulletinPost(id: $id, input: $input) {
      id
      content
      audienceType
      creatorId
      creator {
        id
        firstName
        lastName
        role
      }
      createdAt
      updatedAt
      isDeleted
      targetedUserIds
      priority
      isPinned
      images {
        id
        url
        thumbnailUrl
        width
        height
        size
      }
      attachments {
        id
        url
        fileName
        fileType
        fileSize
        uploadedAt
        isImage
      }
      reactions {
        thumbsUp
        heart
        party
        eyes
      }
    }
  }
`;

export const DELETE_BULLETIN_POST = gql`
  mutation DeleteBulletinPost($id: ID!) {
    deleteBulletinPost(id: $id)
  }
`;

export const ADD_REACTION = gql`
  mutation AddReaction($postId: ID!, $emoji: String!) {
    addReaction(postId: $postId, emoji: $emoji) {
      id
      reactions {
        thumbsUp
        heart
        party
        eyes
      }
    }
  }
`;

export const REMOVE_REACTION = gql`
  mutation RemoveReaction($postId: ID!, $emoji: String!) {
    removeReaction(postId: $postId, emoji: $emoji) {
      id
      reactions {
        thumbsUp
        heart
        party
        eyes
      }
    }
  }
`;

// Bulletin Board Subscriptions
export const ON_BULLETIN_POST_CREATED = gql`
  subscription OnBulletinPostCreated($userId: ID!) {
    onBulletinPostCreated(userId: $userId) {
      id
      content
      audienceType
      creatorId
      creator {
        id
        firstName
        lastName
        role
      }
      createdAt
      updatedAt
      isDeleted
      targetedUserIds
      priority
      isPinned
      images {
        id
        url
        thumbnailUrl
        width
        height
        size
      }
      attachments {
        id
        url
        fileName
        fileType
        fileSize
        uploadedAt
        isImage
      }
      reactions {
        thumbsUp
        heart
        party
        eyes
      }
    }
  }
`;

export const ON_BULLETIN_POST_UPDATED = gql`
  subscription OnBulletinPostUpdated($postId: ID!) {
    onBulletinPostUpdated(postId: $postId) {
      id
      reactions {
        thumbsUp
        heart
        party
        eyes
      }
    }
  }
`;
